// Extreme — 26 numbered tools in 4 blocks (single plate, no KIT). Positions are CARD MILLIMETRES
// on the named face (mx from that face's left edge, my from its top). est:true = my estimate off the
// engraving drawing, waiting for confirmation in the explorer's placement mode.
// Face A = metric side (8–17 mm wrenches, hex 3/4/5, 25 mm ruler). Face B = imperial side.
// hom = photo% -> card fraction, fitted from the STL silhouette (A 0.917, B 0.929).
window.EX = {
 "card": {
  "w": 87.39,
  "h": 55.2,
  "t": 3
 },
 "hom": {
  "A": [[0.009973, -0.004651, 0.230162], [0.009606, 0.01453, -0.621798], [0.000016, 0.001325, 0.94123]],
  "B": [[0.010021, 0.000474, -0.038826], [-0.000053, 0.013878, -0.040617], [0.000206, 0.000609, 0.997442]]
 },
 "blocks": [
  {
   "id": "metric",
   "label": "Metric wrenches & hex",
   "sub": "6–17 mm, three hex keys",
   "tools": [
    {
     "n": 5,
     "cat": "WRENCH",
     "side": "A",
     "mx": 43.4,
     "my": 26.1,
     "est": false,
     "name": "Wrench 12, 13, 14 mm",
     "desc": "The long central staircase carries the three sizes that hold bikes, trailers and garden kit together, each step cut deep enough to take the full corner of the nut.",
     "sc": "13 mm on a bike seat clamp, mid-ride, with the toolbox at home."
    },
    {
     "n": 6,
     "cat": "WRENCH",
     "side": "A",
     "mx": 10.5,
     "my": 25.6,
     "est": false,
     "name": "Open wrench 15, 17 mm",
     "desc": "Two open jaws on the lower-left arm — the big sizes a card this thin usually skips, placed at the edge so your hand gets leverage.",
     "sc": "17 mm axle nut on a wheelbarrow that decided to fall apart on a Sunday."
    },
    {
     "n": 8,
     "cat": "WRENCH",
     "side": "A",
     "mx": 39.1,
     "my": 45.5,
     "est": false,
     "name": "Wrench 6, 7, 9, 11 mm",
     "desc": "Four metric sizes in one staircase — 6, 7, 9 and 11 mm, the run that covers small hardware without a second cutout.",
     "sc": "An 9 mm nut on a stove bracket, tightened before the wind picks up."
    },
    {
     "n": 19,
     "cat": "WRENCH",
     "side": "A",
     "mx": 71.6,
     "my": 28.3,
     "est": false,
     "name": "Wrench 8, 10 mm",
     "desc": "The right-hand cluster: 8 and 10 mm, the two sizes that turn up on almost every appliance and machine bolt.",
     "sc": "M6 bolt on a treadmill panel — one flip of the card instead of a socket set."
    },
    {
     "n": 9,
     "cat": "DRIVE",
     "side": "A",
     "mx": 18.6,
     "my": 55.2,
     "est": false,
     "name": "Hex key 3",
     "desc": "A 3 mm hex socket on the bottom edge, marked with a hexagon so you find it by feel in the dark.",
     "sc": "Set screw on a door handle before it works itself loose completely."
    },
    {
     "n": 18,
     "cat": "DRIVE",
     "side": "A",
     "mx": 87.4,
     "my": 18.9,
     "est": false,
     "name": "Hex key 4",
     "desc": "4 mm hex on the right arm — the single most common size on bike stems and flat-pack furniture.",
     "sc": "Creaking handlebar stem on tour: snug it and ride on."
    },
    {
     "n": 16,
     "cat": "DRIVE",
     "side": "A",
     "mx": 69.5,
     "my": 0,
     "est": false,
     "name": "Hex key 5",
     "desc": "5 mm hex at the top edge, spaced away from the others so the card's own body never blocks the bolt head.",
     "sc": "Bottle-cage bolt on a bike rack, tightened without unpacking anything."
    }
   ]
  },
  {
   "id": "imperial",
   "label": "Imperial & spoke",
   "sub": "5/16–9/16\", spoke gauges",
   "tools": [
    {
     "n": 11,
     "cat": "WRENCH",
     "side": "B",
     "mx": 44.7,
     "my": 9.5,
     "est": false,
     "name": "Wrench 1/2\", 7/16\", 3/8\", 5/16\"",
     "desc": "The imperial staircase mirrors the metric one on the other face: four sizes on one edge, so American hardware needs no second tool.",
     "sc": "Rental trailer with imperial bolts and no adapter in sight."
    },
    {
     "n": 12,
     "cat": "WRENCH",
     "side": "B",
     "mx": 12.6,
     "my": 12.9,
     "est": false,
     "name": "Wrench 9/16\"",
     "desc": "The largest imperial jaw, out on its own arm where the leverage is longest.",
     "sc": "9/16\" on an older lawnmower deck, tightened by hand pressure alone."
    },
    {
     "n": 23,
     "cat": "WRENCH",
     "side": "B",
     "mx": 69.4,
     "my": 5.5,
     "est": false,
     "name": "5/16\" wrench",
     "desc": "A second 5/16\" near the logo, cut at a different angle — the way out when the first jaw cannot reach the nut.",
     "sc": "Nut in a recess where a straight approach is impossible."
    },
    {
     "n": 25,
     "cat": "WRENCH",
     "side": "B",
     "mx": 75.6,
     "my": 44.9,
     "est": false,
     "name": "3/8\" wrench",
     "desc": "Dedicated 3/8\" on the lower right arm, marked in a box so it reads at a glance.",
     "sc": "Imperial hose clamp on a workshop compressor."
    },
    {
     "n": 26,
     "cat": "WRENCH",
     "side": "B",
     "mx": 58.8,
     "my": 39.4,
     "est": false,
     "name": "O₂ bottle wrench",
     "desc": "The odd cutout at the far right corner: the square key for oxygen and gas bottle valves that welders and divers keep asking about.",
     "sc": "Gas bottle swap at a shop where the proper key has walked off."
    },
    {
     "n": 13,
     "cat": "WRENCH",
     "side": "B",
     "mx": 0,
     "my": 41.5,
     "est": false,
     "name": "Spoke wrench 13g, 14g, 15g, 4.3",
     "desc": "Four spoke sizes stacked down the left edge, each circled with its gauge — the wheel-truing block of the card.",
     "sc": "Rear wheel goes out of true 40 km from home; a quarter turn per spoke gets you back."
    }
   ]
  },
  {
   "id": "open",
   "label": "Open, pry & cut",
   "sub": "Cans, boxes, bottles, cord, sparks",
   "tools": [
    {
     "n": 1,
     "cat": "CUT",
     "side": "A",
     "mx": 14.5,
     "my": 1.6,
     "est": false,
     "name": "Can opener",
     "desc": "The hooked notch on the top-left arm walks around a lid the old-fashioned way — slow, but it never needs a battery.",
     "sc": "Tinned food at a campsite where nobody packed the opener."
    },
    {
     "n": 2,
     "cat": "PRY",
     "side": "A",
     "mx": 1.3,
     "my": 0.2,
     "est": false,
     "name": "Pry bar",
     "desc": "The blunt wide tip: 3 mm of hardened steel to lift lids, staples and stuck covers without turning it into a chisel.",
     "sc": "Paint tin lid, or a battery cover that has not moved in years."
    },
    {
     "n": 4,
     "cat": "CUT",
     "side": "A",
     "mx": 8.7,
     "my": 0,
     "est": false,
     "name": "Box opener",
     "desc": "A short hooked blade that rides inside the card's outline, so it slits tape without ever pointing at your hand.",
     "sc": "A stack of parcels and no knife on the desk."
    },
    {
     "n": 3,
     "cat": "FIELD",
     "side": "A",
     "mx": 0,
     "my": 6.3,
     "est": false,
     "name": "Fire starter",
     "desc": "A square-ground scraper edge for a ferro rod — sharp enough to throw sparks, dull enough to stay in your pocket.",
     "sc": "Wet evening, one ferro rod, and the card already in your wallet."
    },
    {
     "n": 22,
     "cat": "FIELD",
     "side": "B",
     "mx": 70.6,
     "my": 2.9,
     "est": false,
     "name": "Bottle opener",
     "desc": "The classic notch on the top edge, marked with a bottle pictogram — the tool everyone finds first.",
     "sc": "Every single time."
    },
    {
     "n": 24,
     "cat": "CUT",
     "side": "B",
     "mx": 65.4,
     "my": 9,
     "est": false,
     "name": "Cord cutter",
     "desc": "A shielded hook edge: cord and zip ties pull into it and part, while the steel around it keeps the edge off your fingers.",
     "sc": "Zip ties on a parcel, paracord on a tarp, seatbelt in an emergency."
    }
   ]
  },
  {
   "id": "drive",
   "label": "Drive & measure",
   "sub": "Bit driver, screwdrivers, rulers, wire",
   "tools": [
    {
     "n": 20,
     "cat": "DRIVE",
     "side": "A",
     "mx": 72.5,
     "my": 41.5,
     "est": false,
     "name": "1/4\" hex bit driver with lock",
     "desc": "The socket plus its two curved slots: drop in a standard hex bit and the lock holds it while the whole card becomes the handle.",
     "sc": "Cabinet hinge backing out mid-move — bit in, twenty seconds, done."
    },
    {
     "n": 7,
     "cat": "DRIVE",
     "side": "A",
     "mx": 0,
     "my": 49.7,
     "est": false,
     "name": "Phillips screwdriver",
     "desc": "A cross tip ground into the left arm, so cross-head screws need no bit at all.",
     "sc": "Smoke-alarm battery cover at 2 a.m."
    },
    {
     "n": 14,
     "cat": "DRIVE",
     "side": "B",
     "mx": 0,
     "my": 55.2,
     "est": false,
     "name": "Flat screwdriver",
     "desc": "The flat blade on the imperial face, wide enough for terminal screws and thin enough for a watch strap pin.",
     "sc": "Loose terminal on a plug, tightened before it arcs."
    },
    {
     "n": 21,
     "cat": "MEASURE",
     "side": "A",
     "mx": 59.6,
     "my": 55.2,
     "est": false,
     "name": "Metric ruler, 25 mm",
     "desc": "A 25 mm scale etched along the bottom edge in millimetre ticks — short, but it is on you, which the tape measure is not.",
     "sc": "Checking a bolt length in a hardware aisle."
    },
    {
     "n": 15,
     "cat": "MEASURE",
     "side": "B",
     "mx": 23.1,
     "my": 55.2,
     "est": false,
     "name": "Inch ruler, 1\"",
     "desc": "The imperial twin on the other face: one inch in sixteenths, so both systems are always a flip apart.",
     "sc": "Imperial drill bit sizing at a friend's workshop."
    },
    {
     "n": 17,
     "cat": "FIELD",
     "side": "A",
     "mx": 62.6,
     "my": 4.9,
     "est": false,
     "name": "Wire bender",
     "desc": "Ø3.5 and Ø2.5 holes at the top edge: push wire through and lever it into a clean right angle or hook.",
     "sc": "Bending a hanger into a hook for a hose clamp."
    },
    {
     "n": 10,
     "cat": "FIELD",
     "side": "A",
     "mx": 21.9,
     "my": 15.9,
     "est": false,
     "name": "Connection holes",
     "desc": "The big round holes double as lanyard points and as the way to bolt two cards together into a longer lever.",
     "sc": "Threading the card onto a keyring, or doubling it up for extra torque."
    }
   ]
  }
 ],
 "specs": [
  {
   "sku": "EXTREME Ti",
   "material": "Titanium Grade 5",
   "size": "85 × 55 × 3 mm",
   "weight": "28 g",
   "hardness": "37–39 HRC",
   "finish": "natural · black"
  },
  {
   "sku": "EXTREME St",
   "material": "440C stainless steel",
   "size": "85 × 55 × 3 mm",
   "weight": "40 g",
   "hardness": "52–54 HRC",
   "finish": "natural · black"
  }
 ]
};
